import React, { Component } from "react";
import Logo from "../Components/Logo";

export default class Footer extends Component {
  render() {
    const { language } = this.props;
    return (
      <footer>
        <Logo src="assets/images/EL_white.svg" alt="Eesti Loto logo" />

        <p className="disclaimer">
          {language === "et"
            ? `Tähelepanu! Tegemist on hasartmängu reklaamiga. Hasartmäng pole
  sobiv viis rahaliste probleemide lahendamiseks. Tutvuge reeglitega
  ja käituge vastutustundlikult!`
            : `Внимание! Вы имеете дело с рекламой азартной игры. Азартные игры не являются средством решения материальных проблем. Ознакомьтесь с правилами и поступайте ответственно!`}
        </p>
      </footer>
    );
  }
}
